import React from 'react';
import './CalloutCardComponent.less';
import ErrorViewComponent from '../ErrorViewComponent/ErrorViewComponent';

function CalloutCardComponent({clearAlert, content, error, errorTitle}) {
    return (
        <div className="CalloutCardComponent box-shadow--nav">
            <ErrorViewComponent error={error} errorTitle={errorTitle} clearAlert={clearAlert}/>
            {content}
        </div>
    );
}

export default CalloutCardComponent;
